import { useQuery } from "@tanstack/react-query";
import { getApiPracticesPracticeIdStripeConfig } from "@/lib/api-client/endpoints/practice-stripe-config/practice-stripe-config";

export const practiceStripeConfigQueryKey = (practiceId: string) =>
  ["practice", practiceId, "stripe-config"] as const;

export function usePracticeStripeConfig(practiceId: string) {
  return useQuery({
    queryKey: practiceStripeConfigQueryKey(practiceId),
    queryFn: () =>
      getApiPracticesPracticeIdStripeConfig(practiceId).then((res) => res.data),
    staleTime: Infinity,
  });
}
